var encode = require('./lib/encoder'),
    decode = require('./lib/decoder');

module.exports = {
  encode: encode,
  decode: decode
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/pureimage/node_modules/jpeg-js/index.js
// module id = QCoQ
// module chunks = 0